import { useRoute, useRouter } from "vue-router";

function router() {
  //跳转路由对象
  const route = useRoute();
  //VueRouter
  const router = useRouter();
  let uRouter = {
    route,
    router,
    push: (url) => {
      router.push(url);
    },
    replace: (url) => {
      router.replace(url);
    },
    back: () => {
      router.go(-1);
    },
    go: (delta) => {
      router.go(delta);
    },
  };
  return uRouter;
}

//const uRouter = {
//  install(Vue) {
//    Vue.provide("$uRouter", router);
//  },
//  uRouter: router,
//};
export default router;

export const $uRouter = router;
